import useWindowDimensions from 'Shared/hooks/useWindowDimensions';

const useCheckIsMobile = () => {
  const {width} = useWindowDimensions();

  return width < 766;
}

export default useCheckIsMobile;
